import React from 'react'
import quizifyLogo from '../../../assets/images/quizify-logo.png'

const Logo = ({ className = '', color, ...props }) => {
    return (
        <img
            src={quizifyLogo}
            className={`quizify-brand-logo ${className}`.trim()}
            alt="Quizify"
            {...props}
        />
    )
}

export default Logo
